// The shell's account control: a visible Sign in when signed out (opens the
// magic-link/Google overlay), or an avatar that opens the account menu
// (Settings, Sign out) when signed in.

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/state/auth";
import { openMenu } from "@/ui/ContextMenu";
import { SignInModal } from "./SignInModal";
import "./account.css";

export function AccountControl() {
  const { user, checked, signout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Avoid a flash of the signed-out button before the session is known.
  if (!checked) return <span className="bd-account__skeleton" aria-hidden />;

  if (!user) {
    return (
      <>
        <button className="bd-account__signin" onClick={() => setOpen(true)}>
          Sign in
        </button>
        <SignInModal open={open} onClose={() => setOpen(false)} />
      </>
    );
  }

  const label = user.name || user.email;
  const initial = (user.name || user.email || "?").trim().charAt(0).toUpperCase();

  return (
    <button
      className="bd-account__avatar"
      aria-label="Account menu"
      onClick={(e) =>
        openMenu(e, [
          { label, disabled: true },
          { label: "", separator: true },
          { label: "Settings", onSelect: () => navigate("/settings") },
          { label: "Sign out", danger: true, onSelect: () => void signout() },
        ])
      }
    >
      {user.avatar ? (
        <img className="bd-account__img" src={user.avatar} alt="" />
      ) : (
        <span className="bd-account__initial">{initial}</span>
      )}
    </button>
  );
}
